import type { ComparisonValue } from '@epilot/journey-logic-commons/src/types/next'
import { LOGIC_OPERATOR } from '@epilot/journey-logic-commons/src/types/next'

import { Operator } from '../operator'

import { Equal } from './equal'

export class NotEqual extends Operator {
  // We use the Equal operator to determine if two values are not equal,
  // because the logic is the same, just inverted.
  private readonly equalOperator = new Equal()

  constructor() {
    super(LOGIC_OPERATOR.NOT_EQUAL)
  }

  /** TODO: unit test */
  evaluate(factValue: unknown, comparisonValue: ComparisonValue): boolean {
    return this.equalOperator.evaluate(factValue, comparisonValue) === false
  }
}
